import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { track } from "../lib/analytics";

export const CITY_DELAYS = {
  "Paris": 25, "Lille": 30, "Lyon": 35, "Nantes": 30, "Bordeaux": 35, "Toulouse": 40,
  "Marseille": 40, "Nice": 40, "Strasbourg": 35, "Rouen": 30, "Mantes-la-Jolie (78)": 20,
  "Les Mureaux": 20, "Cergy-Pontoise": 25, "Évreux": 30, "Amiens": 35, "Le Havre": 35,
};
export const cityDelay = (name) => CITY_DELAYS[name] || null;
export const MIN_REVIEWS = 10; // note moyenne affichée seulement à partir de 10 avis

export const catPrefix = (category = "") => {
  const c = category.toLowerCase();
  if (c.includes("fleur")) return "fleurs";
  if (c.includes("résine") || c.includes("resine")) return "resines";
  if (c.includes("puff")) return "puffs";
  if (c.includes("chicha")) return "chicha";
  return "produit";
};

export const citySlug = (name = "") =>
  name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const productSlug = (name = "") =>
  name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

const CityContext = createContext(null);
export const useCity = () => useContext(CityContext);

export function CityProvider({ children }) {
  const [city, setCity] = useState(() => localStorage.getItem("stuff_city") || "");
  const [vendor, setVendor] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (!city) { setVendor(null); return; }
    api.get("/vendors", { params: { city } })
      .then((r) => {
        const vs = Array.isArray(r.data) ? r.data : [];
        setVendor(vs.find((v) => v.is_live) || vs[0] || null);
      })
      .catch(() => setVendor(null));
  }, [city]);

  const chooseCity = useCallback((name) => {
    setCity(name);
    localStorage.setItem("stuff_city", name);
    setModalOpen(false);
    track("city_selected", { city: name });
  }, []);

  const clearCity = useCallback(() => {
    setCity("");
    localStorage.removeItem("stuff_city");
  }, []);

  const delay = cityDelay(city);
  return (
    <CityContext.Provider value={{ city, vendor, delay, chooseCity, clearCity, modalOpen, setModalOpen }}>
      {children}
    </CityContext.Provider>
  );
}
